const initialState = {
    data: {
        activityCount: [],
        averagePrice: null,
        bottomChannels: [],
        bottomScreenSize: [],
        bottomStores: [],
        prevAveragePrice: null,
        prevBottomChannels: [],
        prevBottomScreenSize: [],
        prevBottomStores: [],
        prevTopBrands: [],
        prevTopChannels: [],
        prevTopModels: [],
        prevTopScreenSizes: [],
        prevTopStores: [],
        topBrands: [],
        topChannels: [],
        topModels: [],
        topScreenSizes: [],
        topStores: [],
        userTypeCounts: [],
    },
    error: null,
    isWorking: false,
}

export default (state = initialState, { type, payload = {} }) => {
    switch (type) {
        case 'API_CALL##FAILURE':
        case 'STATISTICS_FETCH_STORE##FAILURE':
            return {
                ...state,
                error: (payload.response || {}).msg,
                isWorking: false,
            }
        case 'STATISTICS_FETCH##REQUEST':
        case 'STATISTICS_FETCH_STORE##REQUEST':
            return {
                ...state,
                isWorking: true,
            }
        case 'STATISTICS_FETCH##SUCCESS':
            return {
                ...state,
                isWorking: false,
                data: {
                    ...state.data,
                    ...payload,
                    userTypeCounts: payload.userTypeCounts.map(({ returnVisitor, newVisitor, colleague, customer }) => ({
                        returnVisitor: parseInt(returnVisitor, 10),
                        newVisitor: parseInt(newVisitor, 10),
                        colleague: parseInt(colleague, 10),
                        customer: parseInt(customer, 10),
                    })),
                },
            }
        case 'STATISTICS_FETCH_STORE##SUCCESS': {
            const { code: storeCode } = payload
            const {
                data: { bottomStores, topStores },
            } = state
            // Look for the store on bottom stores array, and add the data
            const bottomStoresUpdated = bottomStores.map((store) => {
                const { store_code: storeCodeThis } = store

                if (storeCodeThis !== storeCode) {
                    return store
                }

                return {
                    ...store,
                    store: { ...payload },
                }
            })
            // Look for the store on top stores array, and add the data
            const topStoresUpdated = topStores.map((store) => {
                const { store_code: storeCodeThis } = store

                if (storeCodeThis !== storeCode) {
                    return store
                }

                return {
                    ...store,
                    store: { ...payload },
                }
            })

            return {
                ...state,
                isWorking: false,
                data: {
                    ...state.data,
                    bottomStores: bottomStoresUpdated,
                    topStores: topStoresUpdated,
                },
            }
        }
        default:
            return state
    }
}
